const images = new Map<string, HTMLImageElement>();

export function registerImage(image: HTMLImageElement) {
  const id = crypto.randomUUID();
  images.set(id, image);
  return id;
}

export function findImage(id: string) {
  return images.get(id);
}
